import {
    mapState,
    mapMutations,
    mapActions
} from "vuex";
import Slider from '@vueform/slider'
export default filterMixin = {
    props: ["filter", "title"],
    components: {
        Slider,
    },
    data() {
        return {
            open: false,       
        };
    },

    computed: {
        ...mapState("products", ["selected", "filterDist"]),    
    },
    methods: {
        ...mapMutations("products", ["setAltitude"]),
        ...mapActions("products", ["filterProducts", "applySlider"]),  
        applay() {
            this.close()
            this.applySlider()
        },
        getTotal(key, value){           
          const count = this.filterDist.filter(item=>{
              if(key === 'media' || key === 'category') {
                  if(item.filters[value] === 'Yes'){
                      return item
                  }                  
              }else if(item.filters[key] === value){
                return item
              }          
            }).length
       
            return count
        }
    },
};